// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"gallery-module--wrapper--3C9uO","item":"gallery-module--item--2ewU0"};